// ─── Candidatos a graduación: activos e históricos (M2·H11) ─────────────────
// Caso real (LABTS, 2026-10-18): el reporte de Candidatos mezclaba a quien
// cursa hoy con quien dejó de cursar hace décadas; 74 de los 94 «cerca» tenían
// su último período antes de 2020. No faltaban marcas de egreso (Q14): faltaba
// separar.
//
// ACTIVO = cursa ahora, o su último período con nota empezó hace N años o
// menos. N lo elige cada seminario (`config.candidateActiveYears`, en
// Configuración → Académico); por defecto, 5. Es PRESENTACIÓN: no cambia el
// avance de nadie ni su expediente, solo en qué pestaña aparece.
export const DEFAULT_CANDIDATE_ACTIVE_YEARS = 5;
export function resolveCandidateActiveYears(config) {
    const n = config?.candidateActiveYears;
    return typeof n === 'number' && Number.isInteger(n) && n >= 1
        ? n
        : DEFAULT_CANDIDATE_ACTIVE_YEARS;
}
// «CERCA» de graduarse = le faltan N cursos o menos para alguna credencial.
// N lo elige cada seminario (`config.nearGraduationMaxCourses`, en
// Configuración → Académico); por defecto, 4. También es PRESENTACIÓN: decide
// quién aparece en el reporte, no cambia el avance de nadie.
export const DEFAULT_NEAR_GRADUATION_MAX_COURSES = 4;
export const MAX_NEAR_GRADUATION_MAX_COURSES = 20;
export function resolveNearGraduationMaxCourses(config) {
    const n = config?.nearGraduationMaxCourses;
    return typeof n === 'number' &&
        Number.isInteger(n) &&
        n >= 1 &&
        n <= MAX_NEAR_GRADUATION_MAX_COURSES
        ? n
        : DEFAULT_NEAR_GRADUATION_MAX_COURSES;
}
/** El primer día que todavía cuenta como «reciente»: hoy menos N años. */
export function candidateActiveSince(now, years) {
    const d = new Date(Date.UTC(now.getUTCFullYear() - years, now.getUTCMonth(), now.getUTCDate()));
    return d.toISOString().slice(0, 10);
}
export function isActiveCandidate(input) {
    if (input.inProgress > 0)
        return true;
    if (!input.lastTermStart)
        return false;
    return input.lastTermStart.slice(0, 10) >= candidateActiveSince(input.now, input.years);
}
//# sourceMappingURL=candidate-activity.js.map